
export default {
  getSettings: state => (id) => state.settings.find(setting => setting.id === id)
}
